<template>
  <b-container>
    <div class="exam__category py-3">
      <b-tabs justified>
        <template v-for="(classItem, index) in classList">
          <b-tab :key="classItem.id" :title="classItem.name">
            <template v-slot:title>
              <div :class="'category__item category__item--' + (index + 1)">
                <h4 class="category__name">
                  {{ classItem.name }}
                </h4>
              </div>
            </template>

            <b-row>
              <b-col md="9">
                <b-row>
                  <template v-for="subject in classItem.subjects">
                    <b-col
                      :key="subject.id"
                      md="4"
                      sm="4"
                      xs="4"
                      class="class__subject__item"
                    >
                      <div class="subject__item" @click="redirectToClassSubject(subject)">
                        <div class="subject__item__img"></div>
                        <h4 class="subject__item__title">
                          <b-link
                            :to="{
                              name: 'class-subject',
                              params: { id: subject.id, slug: subject.slug }
                            }"
                            :title="subject.description"
                            >{{ subject.name }}</b-link>
                        </h4>
                      </div>
                    </b-col>
                  </template>
                </b-row>

                <div class="text-center my-3"><em>(<span class="text-red">*</span>) - Vui lòng mua gói luyện tập tương ứng tại <b-link :to="{ name: 'package-list' }">đây</b-link> để bắt đầu luyện tập mục này!</em></div>
              </b-col>
              <b-col md="3">
                <div>
                  <b-link
                    block
                    variant="light"
                    size="sm"
                    class="btn btn-block btn-light mb-3"
                    :to="{ name: 'class-statistic' }"
                  >
                    <img src="@/assets/images/ic_sai.png" alt="" height="30">
                    <span>Kết quả học tập</span>
                  </b-link>
                </div>

                <div>
                  <b-link
                    block
                    variant="light"
                    size="sm"
                    class="btn btn-block btn-light mb-3"
                    :to="{ name: 'class-result' }"
                    disabled
                  >
                    <img src="@/assets/images/ic_sai.png" alt="" height="30">
                    <span>Câu hỏi đã lưu</span>
                  </b-link>
                </div>
              </b-col>
            </b-row>
          </b-tab>
        </template>
      </b-tabs>
    </div>
  </b-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { STORE_KEY } from "../_store/constants";
import { APP_CONFIG } from "@/utils/constants";
import moment from "moment";

export default {
  name: "ClassList",
  data() {
    return {
      cdnUrl: APP_CONFIG.cdnUrl
    };
  },
  metaInfo() {
    return {
      title: "Lớp ôn tập"
    };
  },
  computed: {
    ...mapGetters({
      classList: `${STORE_KEY}/classList`
    })
  },
  beforeMount() {
    this.getClassList();
  },
  methods: {
    ...mapActions(`${STORE_KEY}`, ["getClassList"]),
    parseUTCDate(ts) {
      return moment.unix(ts);
    },
    redirectToClassSubject(subject) {
      this.$router.push({
        name: 'class-subject',
        params: { id: subject.id, slug: subject.slug }
      })
    }
  }
};
</script>
